import { isAdminNotConsultant } from "@/js/http/auth.js";
import AdminProducersSubMenusLinks from "@/components/menu/sub-menus/producers/AdminProducersSubMenusLinks.vue";
import ProducerList from "@/components/producers/ProducerList.vue";
export default {
  name: "adminProducerList",
  components: {
    AdminProducersSubMenusLinks: AdminProducersSubMenusLinks,
    ProducerList: ProducerList
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      selectedTab: null,
      tabs: {
        wineries: "wineries",
        distilleries: "distilleries"
      }
    };
  },
  created: function created() {
    if (this.$route.params && this.$route.params.searchCriterias) {
      this.searchCriterias = this.$route.params.searchCriterias;
    }
    this.selectedTab = this.$route.query.tab || this.tabs.wineries;
  },
  methods: {
    tabChanged: function tabChanged(tab) {
      this.selectedTab = tab;
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};